import { api } from "@/lib/api";

const CHUNK_SIZE = 4 * 1024 * 1024; // 4MB — safely under proxy limits
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Chunked upload to object storage. Returns the stored path.
export async function uploadToStorage(blob, filename, contentType, mediaType, onPct) {
  const totalChunks = Math.ceil(blob.size / CHUNK_SIZE) || 1;
  const { data: init } = await api.post("/uploads/init", {
    filename, content_type: contentType, media_type: mediaType,
    total_chunks: totalChunks, total_size: blob.size });
  for (let i = 0; i < totalChunks; i++) {
    const chunk = blob.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
    const fd = new FormData();
    fd.append("upload_id", init.upload_id);
    fd.append("chunk_index", i);
    fd.append("file", chunk, filename);
    await api.post("/uploads/chunk", fd);
    if (onPct) onPct(Math.round(((i + 1) / totalChunks) * 100));
  }
  const { data: done } = await api.post("/uploads/complete", { upload_id: init.upload_id });
  return done.path;
}

export const mediaUrl = (path) => `${BACKEND}/api/media/file/${path}`;

// Grab a poster frame from a video file, client-side, so the feed isn't a black square.
export function capturePoster(file) {
  return new Promise((resolve) => {
    try {
      const v = document.createElement("video");
      v.preload = "metadata"; v.muted = true; v.playsInline = true;
      v.src = URL.createObjectURL(file);
      const cleanup = () => URL.revokeObjectURL(v.src);
      v.onloadedmetadata = () => { v.currentTime = Math.min(1, (v.duration || 2) / 2); };
      v.onseeked = () => {
        try {
          const canvas = document.createElement("canvas");
          const max = 720; let w = v.videoWidth, h = v.videoHeight;
          if (w > h && w > max) { h = Math.round((h * max) / w); w = max; }
          else if (h > max) { w = Math.round((w * max) / h); h = max; }
          canvas.width = w || 480; canvas.height = h || 480;
          canvas.getContext("2d").drawImage(v, 0, 0, canvas.width, canvas.height);
          canvas.toBlob((b) => { cleanup(); resolve(b); }, "image/jpeg", 0.8);
        } catch (e) { cleanup(); resolve(null); }
      };
      v.onerror = () => { cleanup(); resolve(null); };
    } catch (e) { resolve(null); }
  });
}
